import app from 'flarum/forum/app';
import followingPageOptions from '../../common/utils/followingPageOptions';
export let options;
export const getOptions = () => {
  if (!options) {
    options = followingPageOptions('forum.index.following');
  }
  return options;
};
export const getDefaultFollowingFiltering = () => {
  getOptions();
  let value = app.forum.attribute('fofFollowTagsFollowingPageDefault');
  if (value && !options[value]) {
    value = null;
  }
  if (app.session.user) {
    var _app$session$user$pre;
    const preference = (_app$session$user$pre = app.session.user.preferences()) == null ? void 0 : _app$session$user$pre.followTagsPageDefault;
    if (preference && options[preference]) {
      value = preference;
    }
  }
  return value || 'none';
};
flarum.reg.add('fof-follow-tags', 'forum/utils/getDefaultFollowingFiltering', { options: options,getOptions: getOptions,getDefaultFollowingFiltering: getDefaultFollowingFiltering, });